import { styled } from "@mui/material/styles";
const EmployeeContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%"
}));
const Employee = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: "12px",
  width: "100%"
}));
const Role = styled("div")(() => ({
  color: "#616161",
  fontSize: 13
}));
const Wrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%"
}));
const EmployeeDetails = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%"
}));
export {
  Employee,
  EmployeeContainer,
  EmployeeDetails,
  Role,
  Wrapper
};
